import { createSlice, current } from '@reduxjs/toolkit';

import ImportService from '../../../services/importerService';
import { showMsg } from '../../../services/library';

const deleteImport = async node => {
  try {
    const response = await ImportService.deletePhoto({ dealer_id: node.id, path: node.path });
    if (response.status) {
      const message = [
        `Import deleted permanently`,
        `Folder: ${node.path
          .split('|')
          .join('/')
          .replace(/(\d{4})-(\d{1,2})-(\d{1,2})/, '$2.$3.$1')}`,
        `Dealership: ${node.dealer}`
      ];
      showMsg(message, 'success');
    } else {
      showMsg(response.errors, 'error');
    }
  } catch (error) {
    showMsg(error, 'error');
  }
};

const importSlice = createSlice({
  name: 'import',
  initialState: {
    importDelete: []
  },
  reducers: {
    addToQ: {
      // ADD_IMPORT_DELETE
      reducer(state, action) {
        const { importDelete } = current(state);
        state.importDelete = [...importDelete, action.payload];
      },
      prepare(e) {
        return { payload: e };
      }
    },
    removeFromQ: {
      // REMOVE_IMPORT_DELETE
      reducer(state, action) {
        const { importDelete } = current(state);
        const removed = [
          ...importDelete.filter(p => p.path !== action.payload.path && p.id !== action.payload.id)
        ];
        state.importDelete = removed;
      },
      prepare(e) {
        return { payload: e };
      }
    },
    doDelete: {
      // DO_IMPORT_DELETE
      reducer(state, action) {
        const { importDelete } = current(state);
        let delNode = importDelete.find(p => p.path === action.payload.path && p.id === action.payload.id);
        if (delNode) {
          deleteImport(delNode);
        }
        let remaining = [
          ...importDelete.filter(p => p.path !== action.payload.path && p.id !== action.payload.id)
        ];
        state.importDelete = remaining;
      },
      prepare(e) {
        return { payload: e };
      }
    }
  }
});

export const { addToQ, removeFromQ, doDelete } = importSlice.actions;
export default importSlice.reducer;
